import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import AddDealer from "./AddDealer";
import UpdateDealer from "./UpdateDealer";
import {
  useGetDealersQuery,
  useRemoveDealerMutation,
} from "../../../features/api/dealerApi";
import { toast } from "react-toastify";

const Dealer = () => {
  const { data, isLoading } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = data?.dealer;

  const [removeDealer] = useRemoveDealerMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeDealer(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [searchTerm, setInputValue] = useState("");
  const searchResults = dealers?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Client Management</h1>
        <AddDealer />
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border  focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="py-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : dealers?.length === 0 ? (
          <p className=" text-xl text-red-500 lg:mt-20 md:ml-20">
            There are no Client here
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Name</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Email</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Address</span>
                  </TableCell>
                  {/* <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Mobile</span>
                  </TableCell> */}
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Addressing</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Attention</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Branch</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => (
                    <TableRow key={row?.id}>
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>{row?.d_name}</TableCell>
                      <TableCell>{row?.d_email}</TableCell>
                      <TableCell>{row?.d_address}</TableCell>
                      {/* <TableCell>{row.d_mobile}</TableCell> */}
                      <TableCell>{row?.d_addressing}</TableCell>
                      <TableCell>{row?.d_phone}</TableCell>
                      <TableCell>{row?.d_web}</TableCell>
                      <TableCell className="">
                        <div className="flex items-center gap-x-4">
                          <UpdateDealer dealer={row} />
                          {/* <span onClick={() => handleDelete(row?.id)}>
                            <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                          </span> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={dealers?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Dealer;
